
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const LabResults = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M20,18.7l-4.6-6.8V8.6A2.6,2.6,0,0,0,12.9,6H9.6v5.9L5,18.7a2.4,2.4,0,0,0,1.9,4H18.1a2.5,2.5,0,0,0,2.5-2.5A2.8,2.8,0,0,0,20,18.7Zm-8.9-6.4V7.5h1.8a1,1,0,0,1,1,1.1v3.7l.3.4,1,1.5H9.8l1-1.5Zm7,8.9H6.9a1,1,0,0,1-1-1,1.3,1.3,0,0,1,.3-.7l2.6-3.8h7.4l2.6,3.8a1.3,1.3,0,0,1,.3.7A1,1,0,0,1,18.1,21.2Z"></path>
            <path d="M9.6,3a1.1,1.1,0,0,0,1.1-1.1,1.1,1.1,0,1,0-2.2,0A1.1,1.1,0,0,0,9.6,3Z"></path>
            <circle cx="12.5" cy="4.1" r="1.1"></circle>
          </g>
        </g>
      </g>
    </IconBase>);
};

LabResults.defaultProps = {
  title: 'Lab Results',
};

export default LabResults;
